<template>
  <dv-full-screen-container>
    <AndonHeader />
    <dv-decoration-11 style="width: 100%; height: 60px">
      <dv-digital-flop
        :config="floptextconfig"
        style="width: 200px; height: 50px"
      />
      <dv-digital-flop
        :config="flopOnlineconfig"
        style="width: 200px; height: 50px"
      />

      <dv-digital-flop
        :config="flopdowntextconfig"
        style="width: 200px; height: 50px"
      />
      <dv-digital-flop
        :config="flopDownlineconfig"
        style="width: 200px; height: 50px"
      />
    </dv-decoration-11>
    <div id="dTime">2021-11-23 11:12:33</div>
    <dv-decoration-10 style="width: 100%; height: 5px" />
    <dv-border-box-8 style="width: 100%; height: 50%">
      <dv-border-box-11
        title="生产计划"
        style="width: 50%; height: 100%; display: inline; float: left"
      >
        <dv-scroll-board
          :config="PlanConfig"
          style="width: 80%; height: 70%; margin: 10%"
        />
      </dv-border-box-11>
      <dv-border-box-11
        title="合格率"
        style="width: 25%; height: 100%; display: inline; float: left"
      >
        <dv-decoration-9
          style="
            width: 70%;
            height: 60%;
            margin: 15%;
            margin-top: 25%;
            color: white;
            font-size: 30pt;
          "
        >
          <div id="qualifiedRate">100%</div>
    
        </dv-decoration-9>
      </dv-border-box-11>
      <dv-border-box-11
        title="生产可动率"
        style="width: 25%; height: 100%; display: inline; float: left"
      >
        <dv-decoration-9
          style="
            width: 70%;
            height: 60%;
            margin: 15%;
            margin-top: 25%;
            color: white;
            font-size: 30pt;
          "
        >
          <div id="equipmentOperatRate">100%</div></dv-decoration-9
        >
      </dv-border-box-11>
    </dv-border-box-8>

    <AndonButtom ref="andon_Buttom" v-show="show" />
 
  </dv-full-screen-container>
</template>

<script>
import AndonHeader from "@/components/AndonHeader";
import AndonButtom from "@/components/AndonButtom";
import $ from "jquery";
export default {
  name: "AndonMain",

  components: {
    AndonButtom,
    AndonHeader,
  } /* eslint-disable */,

  methods: {
    timer() {
      return setTimeout(() => {
        //  this.getData();
        //  this.timer();
      }, 1000 * 30);
    },
    getData() {
      var self = this;

      // this.$axios
      //   .get("http://localhost:53301/Andon_TV_Haval.asmx/AndonDataInfo")
      //   //.get(" http://172.12.59.188:8022/Andon_TV_Haval.asmx/AndonDataInfo")
      //   .then((res) => {
      //     $("#dTime").html(res.data.StrDateTime);

      //     this.flopOnlineconfig.number = [res.data.OnlineNumber];
      //     this.flopOnlineconfig = { ...this.flopOnlineconfig };

      //     this.flopDownlineconfig.number = [res.data.DownlineNumber];
      //     this.flopDownlineconfig = { ...this.flopDownlineconfig };

      //     this.PlanConfig.data = eval(res.data.str_ShemeInfos);
      //     this.PlanConfig = { ...this.PlanConfig };

      //     this.$refs.andon_Buttom.me_yearCompelteconfig(
      //       res.data.YearCompleteNumber
      //     );
      //     this.$refs.andon_Buttom.me_MonthCompelteconfig(
      //       res.data.MothCompleteNumber
      //     );

      //     this.$refs.andon_Buttom.me_DayCompelteconfig(
      //       res.data.DayCompleteNumber
      //     );
      //     this.$refs.andon_Buttom.me_downLineEngineTypeconfig(
      //       res.data.DownEngineType
      //     );

      //     this.$refs.andon_Buttom.me_OnEngineTypeconfig(res.data.OnEngineType);

      //     this.$refs.andon_Buttom.me_OnEngineTypeconfig(res.data.OnEngineType);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
    initWebSocket() {
      const wsuri = "ws://119.84.87.151:8084";
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      let actions = { andonTV: "18696696540" };
      this.websocketsend(JSON.stringify(actions));
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      //数据接收
      const redata = JSON.parse(e.data);

      this.show=redata.isShowWarn;

      $("#dTime").html(redata.StrDateTime);

      this.flopOnlineconfig.number = [redata.OnlineNumber];
      this.flopOnlineconfig = { ...this.flopOnlineconfig };

      this.flopDownlineconfig.number = [redata.DownlineNumber];
      this.flopDownlineconfig = { ...this.flopDownlineconfig };

      this.PlanConfig.data = eval(redata.str_ShemeInfos);
      this.PlanConfig = { ...this.PlanConfig };

      this.$refs.andon_Buttom.me_yearCompelteconfig(redata.YearCompleteNumber);
      this.$refs.andon_Buttom.me_MonthCompelteconfig(redata.MothCompleteNumber);
      this.$refs.andon_Buttom.me_DayCompelteconfig(redata.DayCompleteNumber);
      this.$refs.andon_Buttom.me_downLineEngineTypeconfig(
        redata.DownEngineType
      );
      this.$refs.andon_Buttom.me_OnEngineTypeconfig(redata.OnEngineType);

     
      this.$refs.andon_Buttom.me_yearPlanconfig(redata.YearPlanNumber);
      this.$refs.andon_Buttom.me_MonthPlanconfig(redata.MothPlanNumber);
      this.$refs.andon_Buttom.me_DayPlanconfig(redata.DayPlanNumber);






    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
    websocketclose(e) {
      //关闭
      console.log("断开连接", e);
    },
    destroyed() {
      clearInterval(this.timer); //退出页面后销毁定时方法
    },
  },
  created() {
    //this.getData();
    this.initWebSocket();
  },
  //模板渲染完成
  mounted() {
    this.timer();
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      PlanConfig: {
        header: ["<span style ='font-size:25px;'>序号 <span>", "<span style ='font-size:25px;'>系列<span>", "<span style ='font-size:25px;'>机型<span>", "<span style ='font-size:25px;'>计划数量<span>", "<span style ='font-size:25px;'>上线数量<span>"],
        data: [
          ["1", "GW4D24", "ED95", "200", "100"],
          ["2", "GW4D24", "ED95", "200", "100"],
          ["3", "GW4D24", "ED95", "200", "100"],
          ["4", "GW4D24", "ED95", "200", "100"],
          ["5", "GW4D24", "ED95", "200", "100"],
          ["6", "GW4D24", "ED95", "200", "100"],
        ],
      },
      show:true,
      flopOnlineconfig: {
        number: [888888],
        content: "{nt}台",
      },
      flopDownlineconfig: {
        number: [888888],
        content: "{nt}台",
      },
      floptextconfig: {
        content: "当前已上线",
      },
      flopdowntextconfig: {
        content: "当前已下线",
      },
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#dv-full-screen-container {
  background-image: url("../assets/bg.png");
  background-size: 100% 100%;
  box-shadow: 0 0 3px blue;

  flex-direction: column;
}

#dTime {
  float: right;
  padding-right: 5%;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/AndonMain.vue